export default __webpack_public_path__ + "static/media/energy.a8fae30a.svg";